import React from 'react';
import { useTranslation } from 'react-i18next';
// Импортируем иконку (убедись, что путь правильный для твоего проекта)
import { ReactComponent as IconSearchNull } from '../../../assets/images/ic_search_null.svg';

const FormulaNothingFound = ({ searchTerm }) => {
    const { t } = useTranslation();

    return (
        <div className="formula-nothing-found">
            <div className="formula-nothing-found__content">

                {/* Иконка */}
                <div className="formula-nothing-found__icon-wrapper">
                    <IconSearchNull />
                </div>

                {/* Поисковой запрос пользователя */}
                <h2 className="formula-nothing-found__query">
                    "{searchTerm}"
                </h2>

                {/* Описание ошибки */}
                <p className="formula-nothing-found__desc">
                    {t('translate.search_find_error') || 'По этому запросу ничего не найдено'}
                </p>

            </div>
        </div>
    );
};

export default FormulaNothingFound;